import React, { useEffect, useState } from 'react'
import './InstructorSignature.css'
import { getSign, updateSign } from './Queries/InstructorSignatureQueries'
import apollo_client from '../../../../apollo_client';
import moment from 'moment';
import firebase from "../../../../Firebase/firebase";
import { useHistory } from "react-router-dom";
import { useAlert } from "react-alert";
import AWS from 'aws-sdk';
import uniqid from "uniqid";
import dateFormat from "dateformat";
import Iframe from "react-iframe";
import dataUriToBuffer from "data-uri-to-buffer";
import { Select, DatePicker } from "antd";

import Loading from './../../../../assets/images/loading.gif'
function InstructorSignature() {
    const alert = useAlert();
    let history = useHistory();
    const [loading, setloading] = useState(false);
    const [name, setname] = useState("");
    const [users, setuser] = useState([]);
    const [instructorsign, setinstructorsign] = useState("");
    const [examinersign, setexaminersign] = useState("");
    const [instructorapproval, setinstructorapproval] = useState("");
    const [examinerapproval, setexaminerapproval] = useState("");
    const [instructorfile, setinstructorfile] = useState(false);
    const [examinerfile, setexaminerfile] = useState(false);
    const [instructorsignfile, setinstructorsignfile] = useState(false);
    const [examinersignfile, setexaminersignfile] = useState(false);
    const [instvalidity, setinstvalidity] = useState(new Date);
    const [examvalidity, setexamvalidity] = useState(new Date);

    const catagoryy = [
        { catagory: "Update Instructor Signature" },
        { catagory: "Update Examiner Signature" },
        { catagory: "Update Instructor Approval" },
        { catagory: "Update Examiner Approval" },
      ];
      const [catagories, setCatagories] = useState("");
      const Option = Select.Option;
    useEffect(() => {
        firebase.auth().onAuthStateChanged(async (user) => {
            if (user) {
                setloading(true)
                setuser(user.uid)
                let dashboardDet = await apollo_client.query({
                    query: getSign,
                    variables: {
                        id: user.uid
                    }
                });

                if (dashboardDet.data && dashboardDet.data.aatmsv4_simulatorinst[0]?.name) {
                    setname(dashboardDet.data.aatmsv4_simulatorinst[0]?.name)
                }
                if (dashboardDet.data && dashboardDet.data.aatmsv4_simulatorinst[0]?.examinersign) {
                    setexaminersign(dashboardDet.data.aatmsv4_simulatorinst[0]?.examinersign)
                }
                if (dashboardDet.data && dashboardDet.data.aatmsv4_simulatorinst[0]?.instructorsign) {
                    setinstructorsign(dashboardDet.data.aatmsv4_simulatorinst[0]?.instructorsign)
                }
                if (dashboardDet.data && dashboardDet.data.aatmsv4_simulatorinst[0]?.instructorapproval) {
                    setinstructorapproval(dashboardDet.data.aatmsv4_simulatorinst[0]?.instructorapproval)
                }
                if (dashboardDet.data && dashboardDet.data.aatmsv4_simulatorinst[0]?.examinerapproval) {
                    setexaminerapproval(dashboardDet.data.aatmsv4_simulatorinst[0]?.examinerapproval)
                }
                if (dashboardDet.data && dashboardDet.data.aatmsv4_simulatorinst[0]?.instvalidity) {
                    setinstvalidity(dashboardDet.data.aatmsv4_simulatorinst[0]?.instvalidity)

                }
                if (dashboardDet.data && dashboardDet.data.aatmsv4_simulatorinst[0]?.examvalidity) {
                    setexamvalidity(dashboardDet.data.aatmsv4_simulatorinst[0]?.examvalidity)
                }
                setloading(false)
            }
        });
    }, [])

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
    
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
    
        return [year, month, day].join('-');
    }
    const handlemydate =e=> {
        var d = formatDate(e)
        setinstvalidity(e)
        setexamvalidity(e)
    }

    const handleinstdate =e=> {
        setinstvalidity(e)
    }

    const handleexamdate =e=> {
        setexamvalidity(e)
    }

    const  changeData = async ()=>{
        let dashboardDet = await apollo_client.query({
            query: getSign,
            variables: {
                id: users
            }
        });
        
        if (dashboardDet.data && dashboardDet.data.aatmsv4_simulatorinst[0]?.examinersign) {    
            setexaminersign(dashboardDet.data.aatmsv4_simulatorinst[0]?.examinersign)
        }
        if (dashboardDet.data && dashboardDet.data.aatmsv4_simulatorinst[0]?.instructorsign) {
            setinstructorsign(dashboardDet.data.aatmsv4_simulatorinst[0]?.instructorsign)
        }
        if (dashboardDet.data && dashboardDet.data.aatmsv4_simulatorinst[0]?.instructorapproval) {
            setinstructorapproval(dashboardDet.data.aatmsv4_simulatorinst[0]?.instructorapproval)
        }
        if (dashboardDet.data && dashboardDet.data.aatmsv4_simulatorinst[0]?.examinerapproval) {
            setexaminerapproval(dashboardDet.data.aatmsv4_simulatorinst[0]?.examinerapproval)
        }
        if (dashboardDet.data && dashboardDet.data.aatmsv4_simulatorinst[0]?.instvalidity) {
            setinstvalidity(dashboardDet.data.aatmsv4_simulatorinst[0]?.instvalidity)
        }
        if (dashboardDet.data && dashboardDet.data.aatmsv4_simulatorinst[0]?.examvalidity) {
            setexamvalidity(dashboardDet.data.aatmsv4_simulatorinst[0]?.examvalidity)
        }
    }
    const handleInstructorSign = (e) => {
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function () {
            setinstructorsign(reader.result)
            setinstructorsignfile(true);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };

    }
    const handleExaminerSign = (e) => {
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function () {
            setexaminersign(reader.result)
            setexaminersignfile(true);

        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };

    }
    const handleInstructorApproval = (e) => {
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
  
        reader.onload = function () {
            setinstructorapproval(reader.result);
            setinstructorfile(true);
        };

        reader.onerror = function (error) {
            console.log('Error: ', error);
        };

    }
    const handleExaminerApproval = (e) => {
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);

        reader.onload = function () {
            setexaminerapproval(reader.result);
            setexaminerfile(true);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };

    }

    const handleInstValidity = (e) => {
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function () {
            this.setInstValidity(reader.result)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };

    }

    const handleExamValidity = (e) => {
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function () {
            this.setExamValidity(reader.result)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };

    }
    const handleInstructorSave = (e)=>{
        let instructorsigngen = "";
        let id = uniqid();
        if (instructorsignfile) {
            setloading(true);
            const s3 = new AWS.S3({

                correctClockSkew: true,

                endpoint: 'https://s3.eu-central-1.wasabisys.com', //Specify the correct endpoint based on where your bucket is

                accessKeyId: 'NGEXI56XKDO46I0PF3UB',

                secretAccessKey: 'b01KrlUiwgWFk0ZHGz8ch71W9gY9BpMI03qVCO9O',

                region: 'eu-central-1'//Specify the correct region name based on where your bucket is

                , logger: console

            });
            var buf = Buffer.from(instructorsign.replace(/^data:image\/\w+;base64,/, ""), 'base64')
            const uploadRequest = new AWS.S3.ManagedUpload({

                params: {
                    Bucket: 'amiagi/strainersign', Key: users+ id +"_inst" , ContentEncoding: 'base64',
                    ContentType: 'image/png', Body: buf
                },
                service: s3
            });
            uploadRequest.on('httpUploadProgress', function (event) {

                const progressPercentage = Math.floor(event.loaded * 100 / event.total);

                console.log('Upload progress ' + progressPercentage);

            });
            instructorsigngen = 'https://s3.eu-central-1.wasabisys.com/amiagi/strainersign/' + users + id +"_inst";
            console.log('Configed and sending: instructor', instructorsigngen);

            uploadRequest.send(function (err) {
                if (err) {
                    console.log('UPLOAD ERROR: ' + JSON.stringify(err, null, 2));
                } else {
                    apollo_client.mutate({
                        mutation: updateSign,
                        variables: {
                            id: users,
                            name: name,
                            instSign:instructorsigngen,
                            examSign: examinersign,
                            instapproval:instructorapproval,
                            examapproval:examinerapproval,
                            instvalid: moment(instvalidity).format('YYYY-MM-DD'),
                            examvalid: moment(examvalidity).format('YYYY-MM-DD')
                        }
                    }).then(data => {                              
                        changeData();
                        setloading(false);
                        setinstructorsignfile(false);
                        alert.show("Your Instructor Signature was Updated Successfully !");
                    })
                }
            });
        }else{
            alert.show("Upload a signature !");
        }
    }
    const handleExaminerSave = (e)=>{

       
   
        let examinersigngen = "";
        let id = uniqid();
        if (examinersignfile) {
            setloading(true);
            const s3 = new AWS.S3({

                correctClockSkew: true,

                endpoint: 'https://s3.eu-central-1.wasabisys.com', //Specify the correct endpoint based on where your bucket is

                accessKeyId: 'NGEXI56XKDO46I0PF3UB',

                secretAccessKey: 'b01KrlUiwgWFk0ZHGz8ch71W9gY9BpMI03qVCO9O',

                region: 'eu-central-1'//Specify the correct region name based on where your bucket is

                , logger: console

            });
            var buf = Buffer.from(examinersign.replace(/^data:image\/\w+;base64,/, ""), 'base64')
            const uploadRequest = new AWS.S3.ManagedUpload({

                params: {
                    Bucket: 'amiagi/strainersign', Key: users+ id +"_exam" , ContentEncoding: 'base64',
                    ContentType: 'image/png', Body: buf
                },
                service: s3
            });
            uploadRequest.on('httpUploadProgress', function (event) {

                const progressPercentage = Math.floor(event.loaded * 100 / event.total);

                console.log('Upload progress ' + progressPercentage);

            });
            examinersigngen = 'https://s3.eu-central-1.wasabisys.com/amiagi/strainersign/' + users + id +"_exam";
            console.log('Configed and sending: examiner', examinersigngen);

            uploadRequest.send(function (err) {
                if (err) {
                    console.log('UPLOAD ERROR: ' + JSON.stringify(err, null, 2));
                } else {
                    apollo_client.mutate({
                        mutation: updateSign,
                        variables: {
                            id: users,
                            name: name,
                            examSign: examinersigngen,
                            instSign: instructorsign,
                            instapproval:instructorapproval,
                            examapproval:examinerapproval,
                            instvalid: moment(instvalidity).format('YYYY-MM-DD'),
                            examvalid: moment(examvalidity).format('YYYY-MM-DD')
                        }
                    }).then(data => {                              
                        changeData();
                        setloading(false);
                        setexaminersignfile(false);
                        alert.show("Your Examiner Signature was Updated Successfully !");
                    })
                }
            });
        }else{
            alert.show("Upload a signature !");
        }
        
    }
    const handleInstructorAppSave = (e)=>{

       
        let instructorappgen = "";
        let id = uniqid();
        if (instructorfile) {
            setloading(true);
            const s3 = new AWS.S3({

                correctClockSkew: true,

                endpoint: 'https://s3.eu-central-1.wasabisys.com', //Specify the correct endpoint based on where your bucket is

                accessKeyId: 'NGEXI56XKDO46I0PF3UB',

                secretAccessKey: 'b01KrlUiwgWFk0ZHGz8ch71W9gY9BpMI03qVCO9O',

                region: 'eu-central-1'//Specify the correct region name based on where your bucket is

                , logger: console

            });

            var buf = dataUriToBuffer(instructorapproval);

            const uploadRequest = new AWS.S3.ManagedUpload({

                params: {
                    Bucket: 'amiagi/trainerapprovals', Key: users+ id +"_instapp" ,
                    ContentEncoding: 'base64',
                    ContentType: 'application/pdf', Body: buf
                 
                },
                service: s3
            });
            uploadRequest.on('httpUploadProgress', function (event) {

                const progressPercentage = Math.floor(event.loaded * 100 / event.total);

                console.log('Upload progress ' + progressPercentage);

            });
            instructorappgen = 'https://s3.eu-central-1.wasabisys.com/amiagi/trainerapprovals/' + users + id +"_instapp";
            console.log('Configed and sending: instructor approval', instructorappgen);

            uploadRequest.send(function (err) {
                if (err) {
                    console.log('UPLOAD ERROR: ' + JSON.stringify(err, null, 2));
                } else {

                    apollo_client.mutate({
                        mutation: updateSign,
                        variables: {
                            id: users,
                            name: name,
                            instSign: instructorsign,
                            examSign: examinersign,
                            instapproval:instructorappgen,
                            examapproval:examinerapproval,
                            instvalid: moment(instvalidity).format('YYYY-MM-DD'),
                            examvalid: moment(examvalidity).format('YYYY-MM-DD')
                        }
                    }).then(data => {                              
                        changeData();
                        setloading(false);
                        setinstructorfile(false);
                        alert.show("Instructor Approval Updated Successfully !");
                    })
                }
            });
        } else{
            alert.show("Upload a document!");
        }
    }
    const handleExaminerAppSave = (e)=>{

      
        let examinerappgen = "";
        let id = uniqid();
        if (examinerfile) {
            setloading(true);
            const s3 = new AWS.S3({

                correctClockSkew: true,

                endpoint: 'https://s3.eu-central-1.wasabisys.com', //Specify the correct endpoint based on where your bucket is

                accessKeyId: 'NGEXI56XKDO46I0PF3UB',

                secretAccessKey: 'b01KrlUiwgWFk0ZHGz8ch71W9gY9BpMI03qVCO9O',

                region: 'eu-central-1'//Specify the correct region name based on where your bucket is
                , logger: console

            });
           
            var buf = dataUriToBuffer(examinerapproval);
            const uploadRequest = new AWS.S3.ManagedUpload({

                params: {
                    Bucket: 'amiagi/trainerapprovals', Key: users+ id +"_examapp.pdf" , ContentEncoding: 'base64',
                    Body: buf,
                    ContentType: 'application/pdf'

                },
                service: s3
            });
            uploadRequest.on('httpUploadProgress', function (event) {

                const progressPercentage = Math.floor(event.loaded * 100 / event.total);

                console.log('Upload progress ' + progressPercentage);

            });
            examinerappgen = 'https://s3.eu-central-1.wasabisys.com/amiagi/trainerapprovals/' + users + id +"_examapp.pdf";
            console.log('Configed and sending: examiner approval', examinerappgen);

            uploadRequest.send(function (err) {
                if (err) {
                    console.log('UPLOAD ERROR: ' + JSON.stringify(err, null, 2));
                } else {

                    apollo_client.mutate({
                        mutation: updateSign,
                        variables: {
                            id: users,
                            name: name,
                            instSign: instructorsign,
                            examSign: examinersign,
                            instapproval:instructorapproval,
                            examapproval:examinerappgen,
                            instvalid: moment(instvalidity).format('YYYY-MM-DD'),
                            examvalid: moment(examvalidity).format('YYYY-MM-DD')
                        }
                    }).then(data => {                              
                        changeData();
                        setloading(false);
                        setexaminerfile(false);
                        alert.show("Examiner Approval Updated Successfully ! ");
                    })
                }
            });
        }
        else{
            alert.show("Upload a document !");
        }
    }

    if (loading) {

        return (< img style={{ padding: 100 }} src={loading ? Loading : null}
            height="30%"
            alt=""
            width="30%"
        />)
    }
    return (
        <div className="simulator-dashboard">
                <div className=" medium-margin-top">
                    <h3 className="bold">What do you wish to update ?</h3>

                    <div style={{width:"250px"}}>
                            <Select 
                            value={catagories ? catagories : "Select one parameter"}
                            onChange={(e) => setCatagories(e)}
                            >
                            {catagoryy?.map((el, i) => (
                                <Option key={i} value={el?.catagory}>
                                {el?.catagory}
                                </Option>
                            ))}
                            </Select>
                    </div>
                </div>
            <div className="  medium-margin-top category-title">
                View current signature / approval and update if required.
            </div>

            {catagories === "Update Instructor Signature" ? (
                    <div>
                        <div>
                            <div className="message-container">
                            Note: Update your instructor signature here. This signature is used to sign forms completed by you.
                                <br/><br className="medium-margin-top" />Procedure: On a white sheet, make a 2” x 5”, box affix your stamp and signature and upload the image.
                            </div>
                        </div>

                        <div className=" medium-margin-top ">
                            <div className=" signature__namebox center">
                                <h3 className="bold">Name:</h3> &nbsp; &nbsp;
                                <input className="signature__namebox--input" disabled type="text" onChange={e => setname(e.target.value)} value={name} name="Name" />
                            </div>

                          
                         </div>

                        <div className="simulator-imagebox medium-margin-top">
                            <div className="simulator-imagebox--left">
                                <h3>Upload Istructor Stamp & Signature</h3>
                                <img key={instructorsign} cache={false} width="100%" src={instructorsign} alt="" />

                                <div className="simulator-filebox">
                                    <div>
                                        <label style={{lineHeight:"34px"}} htmlFor="file1"className="crew-button">Choose File To Update Signature </label>
                                        <input id="file1" style={{visibility:"hidden",width:"0px"}} className="file-input" type="file" onChange={handleInstructorSign} accept="application/jpg,application/png" />
                                    </div>
        
                                        <button style={{width:"100px",cursor:"pointer"}} disabled={name === ''|| instructorsign === ''} onClick={handleInstructorSave} className="crew-button">Save</button>
                                </div> 
                            </div>
                        </div>    
                    </div>
            ) : null}

            {catagories === "Update Examiner Signature" ? (
                        <div>
                            <div className="message-container">
                            Note: Update your examiner signature here. This signature is used to sign forms completed by you.
                                <br/><br className="medium-margin-top" /> Procedure: On a white sheet, make a 2” x 5”, box affix your stamp and signature and upload the image.
                            </div>
                            <div className=" medium-margin-top ">
                                <div className=" signature__namebox center">
                                    <h3 className="bold">Name:</h3> &nbsp; &nbsp;
                                    <input className="signature__namebox--input" disabled type="text" onChange={e => setname(e.target.value)} value={name} name="Name" />
                                </div>
                            </div>

                            <div className="simulator-imagebox medium-margin-top">
                                <div className="simulator-imagebox--left">
                                    <h3>Upload Examinar Stamp & Signature</h3>
                                    <img  width="100%" src={examinersign} alt="" />
    
                                    <div className="simulator-filebox">
                                        <div>
                                            <label style={{lineHeight:"34px"}} htmlFor="file2"className="crew-button">Choose File To Update Signature  </label>
                                            <input id="file2" style={{visibility:"hidden"}} className="file-input" type="file" name="resume" onChange={handleExaminerSign} accept="application/jpg,application/png" />
                                        </div>
                                            <button style={{width:"100px",cursor:"pointer"}} disabled={ examinersign === ''} onClick={handleExaminerSave} className="crew-button">Save</button>
                                    </div>
                                    
                                </div>
                       
                            </div>    
                        </div>

                        ) : null}

            {catagories === "Update Instructor Approval" ? (
                        <div>
                            <div className="message-container">
                            Note:<br/> a. Upload all approvals in a single PDF. Page 1 of PDF will be the DGCA approval, page 2 Standardisation Report & page 3 Trainer refresher certificate.<br/>
                            b. Enter the earliest expiry date. (Example: if DGCA approval is lapsing on 1/1/2022, standardisation is lapsing on . 10/12/2021 & trainer refresher is lapsing on 1/10/2021. 
                            Enter the expiry date as 1/10/2021 [earliest date]).
                            </div>

                            <div className=" medium-margin-top ">
                                <div className=" signature__namebox center">
                                    <h3 className="bold">Name:</h3> &nbsp; &nbsp;
                                    <input className="signature__namebox--input" disabled type="text" onChange={e => setname(e.target.value)} value={name} name="Name" />
                                </div>
                            </div>

                            <div className="simulator-imagebox medium-margin-top">
                                <div className="simulator-imagebox--left">
                                    <h3>Upload latest Instructor Approval</h3>
                                 
                                   {instructorapproval?<Iframe  className="instructor-pdf" url={instructorapproval} />:null}

                                    <div  className="simulator-filebox">
                                        <div>
                                            <input id="file3" className="file-input" type="file" name="resume" onChange={handleInstructorApproval} />
                                            <label style={{lineHeight:"34px"}} htmlFor="file3"className="crew-button">Choose File to Update Instructor Approval</label>
                                        </div>
                                     
                                            <button style={{width:"100px",marginTop:"40px",cursor:"pointer"}} disabled={instructorapproval === ''} onClick={handleInstructorAppSave} className="crew-button">Save</button>
                                    
                                    </div>
                                </div>

                                <div className="simulator-imagebox--right">
                                    <h3>Instructor Privileges Valid Till ?</h3>
                                    <DatePicker placeholderText="Select a date"
                                        
                                                defaultValue={moment(instvalidity)} 
                                                onChange={handleinstdate}
                                                style={{width:"300px"}}  className=" medium-margin-top " format="DD/MM/YYYY"  />
                                </div>
                               
                            </div>   
                        </div>
                        ) : null}

            {catagories === "Update Examiner Approval" ? (
                        <div>
                            <div className="message-container">
                                Note:<br/> a. Upload a single PDF.  Page 1 of the PDF will be the DGCA approval, Page 2 the Standardisation Report, Page 3 Trainer ground refresher certificate & page 4 DGCA DE refresher certificate.<br/>
                                b. Enter the earliest expiry date. (Example:
                                if DGCA approval lapsing 1/1/2022, standardisation lapsing on 10/12/2021, Trainer refresher
                                lapsing 1/10/2021 & DGCA refresher lapsing 15/9/2021. Enter the expiry date as 15/9/2021 [earliest date]).
                            </div>

                            <div className=" medium-margin-top ">
                                <div className=" signature__namebox center">
                                    <h3 className="bold">Name:</h3> &nbsp; &nbsp;
                                    <input className="signature__namebox--input" disabled type="text" onChange={e => setname(e.target.value)} value={name} name="Name" />
                                </div>
                            </div>

                            <div className="simulator-imagebox medium-margin-top">
                                <div className="simulator-imagebox--left">
                                    <h3>Upload Latest Examiner Approval</h3>
                                    {instructorapproval?<Iframe className="instructor-pdf" url={examinerapproval} />:null}
                                   
                                   

                                    <div className="simulator-filebox">
                                        <div>
                                            <input id="file4" className="file-input" type="file" name="resume" onChange={handleExaminerApproval}  />
                                            <label style={{lineHeight:"34px"}} htmlFor="file4"className="crew-button">Choose File to Update Examiner Approval</label>
                                        </div>
                                            <button style={{width:"100px",marginTop:"40px",cursor:"pointer"}} disabled={examinerapproval === ''} onClick={handleExaminerAppSave} className="crew-button">Save</button>
                                    </div>
                                </div>

                                <div className="simulator-imagebox--right">
                                    <h3>Examiner Privileges Valid Till</h3>
                                    <DatePicker 
                                              defaultValue={moment(examvalidity)} 
                                                onChange={handleexamdate}
                                                style={{width:"300px"}}  className=" medium-margin-top " format="DD/MM/YYYY" />
                                </div>
                            </div>   
                        </div>
                        ) : null}
        </div>
    )
}

export default InstructorSignature
